import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes, faGlobe, faUser } from '@fortawesome/free-solid-svg-icons';

const AutomaticMessagesFilters = ({
    searchTerm,
    onSearchChange,
    filterType,
    onFilterChange,
    totalCount = 0,
    generalCount = 0,
    personalCount = 0,
    isDark
}) => {
    return (
        <div
            className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3 pt-2 border-top"
            style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}
        >
            {/* Input Búsqueda */}
            <div
                className="d-flex align-items-center gap-2 px-3 py-1 border rounded-pill"
                style={{
                    width: '360px',
                    maxWidth: '100%',
                    backgroundColor: isDark ? '#182635' : '#f8fafc',
                    borderColor: isDark ? '#233142' : '#e2e8f0'
                }}
            >
                <FontAwesomeIcon icon={faSearch} className="text-muted" style={{ fontSize: '0.82rem' }} />
                <input
                    type="text"
                    className="border-0 bg-transparent shadow-none w-100"
                    style={{ fontSize: '0.84rem', outline: 'none', color: isDark ? '#f9fafd' : '#0f172a' }}
                    placeholder="Buscar por categoría, mensaje o asesor..."
                    value={searchTerm}
                    onChange={e => onSearchChange(e.target.value)}
                />
                {searchTerm && (
                    <button
                        type="button"
                        className="btn btn-sm p-0 text-muted border-0 bg-transparent shadow-none"
                        onClick={() => onSearchChange('')}
                    >
                        <FontAwesomeIcon icon={faTimes} style={{ fontSize: '0.75rem' }} />
                    </button>
                )}
            </div>

            {/* Píldoras de Filtro */}
            <div className="d-flex align-items-center gap-1.5 flex-wrap">
                <button
                    type="button"
                    className={`btn btn-sm rounded-pill px-3 shadow-none border ${
                        filterType === 'all' ? 'btn-primary text-white' : ''
                    }`}
                    style={{
                        fontSize: '0.78rem',
                        fontWeight: filterType === 'all' ? 600 : 500,
                        backgroundColor: filterType === 'all' ? undefined : (isDark ? '#182635' : '#f8fafc'),
                        borderColor: filterType === 'all' ? undefined : (isDark ? '#233142' : '#e2e8f0'),
                        color: filterType === 'all' ? undefined : (isDark ? '#94a3b8' : '#64748b')
                    }}
                    onClick={() => onFilterChange('all')}
                >
                    Todos ({totalCount})
                </button>
                <button
                    type="button"
                    className={`btn btn-sm rounded-pill px-3 shadow-none border ${
                        filterType === 'general' ? 'btn-info text-white' : ''
                    }`}
                    style={{
                        fontSize: '0.78rem',
                        fontWeight: filterType === 'general' ? 600 : 500,
                        backgroundColor: filterType === 'general' ? undefined : (isDark ? '#182635' : '#f8fafc'),
                        borderColor: filterType === 'general' ? undefined : (isDark ? '#233142' : '#e2e8f0'),
                        color: filterType === 'general' ? undefined : (isDark ? '#94a3b8' : '#64748b')
                    }}
                    onClick={() => onFilterChange('general')}
                >
                    <FontAwesomeIcon icon={faGlobe} className="me-1" />
                    Global ({generalCount})
                </button>
                <button
                    type="button"
                    className={`btn btn-sm rounded-pill px-3 shadow-none border ${
                        filterType === 'personal' ? 'btn-success text-white' : ''
                    }`}
                    style={{
                        fontSize: '0.78rem',
                        fontWeight: filterType === 'personal' ? 600 : 500,
                        backgroundColor: filterType === 'personal' ? undefined : (isDark ? '#182635' : '#f8fafc'),
                        borderColor: filterType === 'personal' ? undefined : (isDark ? '#233142' : '#e2e8f0'),
                        color: filterType === 'personal' ? undefined : (isDark ? '#94a3b8' : '#64748b')
                    }}
                    onClick={() => onFilterChange('personal')}
                >
                    <FontAwesomeIcon icon={faUser} className="me-1" />
                    Por Asesor ({personalCount})
                </button>
            </div>
        </div>
    );
};

export default AutomaticMessagesFilters;
